import { SelectItem } from 'primeng/api';
import { OrderPriority } from '../enums/order-priority';

export class OrderPriorityLookup {

    static getLookup(): SelectItem[] {
        return [
            { label: 'Normal', value: OrderPriority.Normal },
            { label: 'Urgent', value: OrderPriority.Stat },
        ];
    }

    static getLabOrderPriorityLookup(): SelectItem[] {
        return [
            { label: 'Normal', value: OrderPriority.Normal },
            { label: 'Stat', value: OrderPriority.Stat },
            { label: 'Initial', value: OrderPriority.Initial },
            { label: 'Regular', value: OrderPriority.Regular },
            { label: 'Urgent', value: OrderPriority.Urgent },
        ];
    }


    static getAllLookup(): SelectItem[] {
        return [
            { label: 'All', value: null },
            { label: 'Normal', value: OrderPriority.Normal },
            { label: 'Stat', value: OrderPriority.Stat },
            { label: 'Initial', value: OrderPriority.Initial },
            { label: 'Regular', value: OrderPriority.Regular },
            { label: 'Urgent', value: OrderPriority.Urgent },
        ];
    }
}
